import { PageHeader } from '@panwds/react-ui'
import type { VFC } from 'react'

const CommonServicePageHeader: VFC<{ title: string, subTitle?: string }> = ({ title, subTitle }) => (
  <PageHeader
    title={title}
    subtitle={subTitle}
    addClassName='cm-p-3 cm-bg-gray-100 dark:cm-bg-gray-1050 dark:cm-border-solid dark:cm-border-x-0 dark:cm-border-b-1 dark:cm-border-t-0 dark:cm-border-gray-950'
  />
)

export default CommonServicePageHeader
